module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAA1UlEQVQokY3Qv0rCYRTG8c9PDaKGhKIhaHOLoCnQ2aFZaJQWlyaFcGhoEBfLqStwj26iIfAaohtwcshFKGjw/YH8OJnPcs77nOf7/ssWg45Au3jDPur4KgZKEYUuLnGGfhSIwCPcr63vcLIN+IADfOIDexj+B9Zwm/pXTFJ/g/NN4Ag7wS3KePoLbKAVQLmu0CyCGcapbtI4Z3KwlU5cVxWHBe8CbahYvWkU7H6N78Af4qVi9Yu1IPCIJZ4L/il62WLQmeE4AH9SLQezeQnTYJADEQTvvznoHKKjVgBXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/error-time-icon.png
// module id = YHxv
// module chunks = 1